module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', _vm._g({
    staticClass: "items-images-thumbnail",
    style: ({
      'background-image': ("url(" + _vm.imgSrc + ")")
    })
  }, _vm.$listeners), [(_vm.item.isFolder) ? _c('div', {
    staticClass: "item-category-name-layer"
  }, [_c('router-link', {
    attrs: {
      "to": ("/referenciak/" + (_vm.item.id))
    }
  }, [_vm._v("\n      " + _vm._s(_vm.item.name) + "\n    ")])], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7adb3fc1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReferenceItem.vue
// module id = 947
// module chunks = 0